<template>
  <div class="container">
    <div class="back" @click="back">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('back') }}</span>
    </div>
    <div class="anchor">
      <div v-for="(i, inx) in getAnchorList" :key="inx" @click="changeAnchor(i)">
        <a :style="{ fontWeight: i.checked ? 'bold' : '' }">{{ $t(i.nameKey) }}</a>
        <div class="checked" v-show="i.checked"></div>
      </div>
    </div>
    <div class="scrollContent">
      <div id="基本数据" class="base">
        <div class="title">
          <span>{{ $t('basicData') }}</span>
          <a-button type="primary" @click="exportExcel">{{ $t('exportReport') }}</a-button>
        </div>
        <a-table :locale="locale" :columns="classColumns" :data-source="classData"></a-table>
      </div>
      <div id="听课时长">
        <div class="title">
          <span>{{ $t('listeningDuration') }}</span>
        </div>
        <div class="overview" v-if="!noDataAttendance">
          <span>{{ $t('dataOverview.longestListening') }}：{{ overviewAttendance.maxAttendanceDurationStudent }} ({{
            formatSeconds(overviewAttendance.maxAttendanceDuration)
          }})</span>
          <span>{{ $t('dataOverview.shortestListening') }}：{{ overviewAttendance.minAttendanceDurationStudent }} ({{
            formatSeconds(overviewAttendance.minAttendanceDuration)
          }})</span>
        </div>
        <div class="overview" v-else>
          <span>{{ $t('dataOverview.longestListening') }}：{{ $t('dataOverview.noStudent') }}</span>
          <span>{{ $t('dataOverview.shortestListening') }}：{{ $t('dataOverview.noStudent') }}</span>
        </div>
        <div class="detail">
          <div class="echart" ref="echartAttendance"></div>
          <div class="noData" v-show="noDataAttendance">
            <img src="@/assets/img/bj_zanwu_echarts.png" alt="">
            <span>{{ $t('noDataEmpty') }}</span>
          </div>
        </div>
      </div>
      <div id="播控">
        <div class="title">
          <span>{{ $t('playbackControl') }}</span>
        </div>
        <div class="overview" v-if="!noDataTraining">
          <span>{{ $t('dataOverview.mostPlayback') }}：{{ overviewTraining.maxTrainingCountStudent }}
            ({{ overviewTraining.maxTrainingCount }}{{ $t('dataOverview.times') }})</span>
          <span>{{ $t('dataOverview.leastPlayback') }}：{{ overviewTraining.minTrainingCountStudent }}
            ({{ overviewTraining.minTrainingCount }}{{ $t('dataOverview.times') }})</span>
        </div>
        <div class="overview" v-else>
          <span>{{ $t('dataOverview.mostPlayback') }}：{{ $t('dataOverview.noStudent') }}</span>
          <span>{{ $t('dataOverview.leastPlayback') }}：{{ $t('dataOverview.noStudent') }}</span>
        </div>
        <div class="detail">
          <div class="echart" ref="echartTraining"></div>
          <div class="noData" v-show="noDataTraining">
            <img src="@/assets/img/bj_zanwu_echarts.png" alt="">
            <span>{{ $t('noDataEmpty') }}</span>
          </div>
        </div>
      </div>
      <div id="虚拟示教">
        <div class="title">
          <span>{{ $t('virtualTeaching') }}</span>
        </div>
        <div class="overview" v-if="!noDataTeach">
          <span>{{ $t('dataOverview.longestTeaching') }}：{{ overviewTeach.maxTeachDurationStudent }} ({{
            formatSeconds(overviewTeach.maxTeachDuration)
          }})</span>
          <span>{{ $t('dataOverview.shortestTeaching') }}：{{ overviewTeach.minTeachDurationStudent }} ({{
            formatSeconds(overviewTeach.minTeachDuration)
          }})</span>
        </div>
        <div class="overview" v-else>
          <span>{{ $t('dataOverview.longestTeaching') }}：{{ $t('dataOverview.noStudent') }}</span>
          <span>{{ $t('dataOverview.shortestTeaching') }}：{{ $t('dataOverview.noStudent') }}</span>
        </div>
        <div class="detail">
          <div class="echart" ref="echartTeach"></div>
          <div class="noData" v-show="noDataTeach">
            <img src="@/assets/img/bj_zanwu_echarts.png" alt="">
            <span>{{ $t('noDataEmpty') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from 'echarts'
import { lessonData, lessonDataExport } from '@/api/lesson'
import NoData from '@/components/noData/index'
import Pagination from '@/components/pagination/index.vue'
import { formatSeconds } from '@/utils/util'

export default {
  components: {
    NoData,
    Pagination
  },
  data() {
    return {
      id: undefined,
      classData: [],
      tabKey: 1,
      locale: {
        emptyText: <NoData />
      },
      trainingDetailKey: undefined,
      baseData: {},
      classColumns: [
        {
          title: this.$t('tableColumns.class'),
          key: 'className',
          align: 'center',
          dataIndex: 'className'
        },
        {
          title: this.$t('tableColumns.lectureDuration'),
          align: 'center',
          key: 'lectureDuration',
          dataIndex: 'lectureDuration'
        },
        {
          title: this.$t('tableColumns.coursewareCount'),
          key: 'clickResCount',
          align: 'center',
          dataIndex: 'clickResCount'
        },
        {
          title: this.$t('tableColumns.playbackCount'),
          align: 'center',
          key: 'playResCount',
          dataIndex: 'playResCount'
        },
        {
          title: this.$t('tableColumns.teachingCount'),
          align: 'center',
          key: 'teachResCount',
          dataIndex: 'teachResCount'
        },
        {
          title: this.$t('tableColumns.studentCount'),
          align: 'center',
          key: 'attendanceCount',
          dataIndex: 'attendanceCount'
        },
        {
          title: this.$t('tableColumns.playbackStudents'),
          align: 'center',
          key: 'trainingCount',
          dataIndex: 'trainingCount'
        },
        {
          title: this.$t('tableColumns.teachingStudents'),
          align: 'center',
          key: 'teachCount',
          dataIndex: 'teachCount'
        },
        {
          title: this.$t('tableColumns.attendanceRate'),
          align: 'center',
          key: 'attendanceRate',
          dataIndex: 'attendanceRate'
        },
        {
          title: this.$t('tableColumns.playbackRate'),
          align: 'center',
          key: 'trainingRate',
          dataIndex: 'trainingRate'
        },
        {
          title: this.$t('tableColumns.teachingRate'),
          align: 'center',
          key: 'teachRate',
          dataIndex: 'teachRate'
        }
      ],
      getAnchorList: [
        {
          nameKey: 'basicData',
          name: '基本数据',
          checked: true
        },
        {
          nameKey: 'listeningDuration',
          name: '听课时长',
          checked: false
        },
        {
          nameKey: 'playbackControl',
          name: '播控',
          checked: false
        },
        {
          nameKey: 'virtualTeaching',
          name: '虚拟示教',
          checked: false
        }
      ],
      attendanceList: [],
      trainingList: [],
      teachList: [],
      overviewAttendance: {},
      overviewTraining: {},
      overviewTeach: {}
    }
  },
  computed: {
    noDataAttendance() {
      return this.attendanceList.length === 0
    },
    noDataTraining() {
      return this.trainingList.length === 0
    },
    noDataTeach() {
      return this.teachList.length === 0
    }
  },
  methods: {
    back() {
      this.$router.back()
    },
    formatSeconds(second) {
      return formatSeconds(second)
    },
    changeAnchor(item) {
      const scrollContent = document.querySelector('.scrollContent')
      const section = document.querySelector('#' + item.name)
      scrollContent.scrollTo({ left: 0, top: section.offsetTop - 210, behavior: 'smooth' })
      this.getAnchorList.forEach(item => {
        item.checked = false
      })
      item.checked = true
    },
    // 滚动到对应内容后，改变导航栏
    handleScorll() {
      const scrollContent = document.querySelectorAll('.scrollContent')
      scrollContent.forEach(item => {
        item.addEventListener('scroll', () => {
          const scrollPosition = item.scrollTop + 210
          this.getAnchorList.forEach((link, inx) => {
            const section = document.querySelector('#' + link.name)
            const sectionTop = section.offsetTop
            const sectionHeight = section.clientHeight
            console.log(scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight, scrollPosition, sectionTop, scrollPosition, sectionTop, sectionHeight)
            if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
              this.getAnchorList[inx].checked = true
            } else {
              this.getAnchorList[inx].checked = false
            }
          })
        })
      })
    },
    exportExcel() {
      lessonDataExport({ id: this.id }).then(res => {
        const blob = new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' })
        const name = `${this.lessonName}${new Date().toLocaleDateString()}报告`
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, name)
        } else {
          var downloadElement = document.createElement('a')
          var href = window.URL.createObjectURL(blob)
          downloadElement.href = href
          downloadElement.download = name
          document.body.appendChild(downloadElement)
          downloadElement.click()
          document.body.removeChild(downloadElement)
          window.URL.revokeObjectURL(href)
        }
        this.$message.success(this.$t('downloadSuccess'))
      })
    },
    initEchartAttendance(xAxisArr = [], yAxisArr = []) {
      this.echartAttendance = echarts.init(this.$refs.echartAttendance)
      if (this.noDataAttendance) {
        xAxisArr = this.studentList
        yAxisArr = this.studentList.map(item => 0)
      }
      const optionTitle = this.echartsConfig({
        dataX: xAxisArr,
        dataY: yAxisArr,
        titleY: '分钟',
        title: '听课时长',
        colorStart: '#40E19B',
        colorEnd: '#18C590',
        min: this.noDataAttendance ? 10 : null
      })
      this.echartAttendance.setOption(optionTitle)
    },
    initEchartTraining(xAxisArr = [], yAxisArr = [], detailInfo) {
      this.echartTraining = echarts.init(this.$refs.echartTraining)
      if (this.noDataTraining) {
        xAxisArr = this.studentList
        yAxisArr = this.studentList.map(item => 0)
      }
      const optionTitle = this.echartsConfig({
        dataX: xAxisArr,
        dataY: yAxisArr,
        titleY: '次',
        title: '播控次数',
        detailInfo,
        colorStart: '#0F8BDB',
        colorEnd: '#407EE1',
        min: this.noDataTraining ? 10 : null
      })
      this.echartTraining.setOption(optionTitle)
    },
    initEchartTeach(xAxisArr = [], yAxisArr = []) {
      this.echartTeach = echarts.init(this.$refs.echartTeach)
      if (this.noDataTeach) {
        xAxisArr = this.studentList
        yAxisArr = this.studentList.map(item => 0)
      }
      const optionTitle = this.echartsConfig({
        dataX: xAxisArr,
        dataY: yAxisArr,
        titleY: '分钟',
        title: '示教时长',
        colorStart: '#40C2E1',
        colorEnd: '#0F81DB',
        min: this.noDataTeach ? 10 : null
      })
      this.echartTeach.setOption(optionTitle)
    },
    echartsConfig(config) {
      return {
        tooltip: {
          padding: [8, 12, 8, 12],
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12,
            lineHeight: 20
          },
          trigger: 'item',
          confine: true,
          formatter: params => {
            const detailInfo = params.data.detailInfo ? params.data.detailInfo.join('<br/>') : ''
            if (params.data.detailInfo) return detailInfo
            return `${params.name} : ${formatSeconds(params.value * 60)} `
          }
        },
        grid: {
          show: true,
          borderWidth: 0,
          backgroundColor: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#FFFFFF' }, // 渐变色起始颜色
            { offset: 1, color: '#F2F7FF' } // 渐变色结束颜色
          ]),
          left: '3%',
          right: '0%',
          top: '15%',
          bottom: '10%' // 调整下边距
        },
        xAxis: {
          type: 'category',
          data: config.dataX,
          maxWidth: 120,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#fff',
              width: 0,
              type: 'solid'
            }
          },
          axisTick: {
            show: true
          },
          axisLabel: {
            // x轴文字的配置
            show: true,
            textStyle: {
              color: '#262626',
              fontSize: 12
            }
          }
        },
        yAxis: {
          type: 'value',
          name: config.titleY,
          axisLine: {
            show: true,
            lineStyle: {
              show: true, // 是否显示坐标轴轴线，
              color: '#E5E5E5', // x轴轴线的颜色
              width: 1 // x轴粗细
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dotted' // 设置网格线类型 dotted：虚线 solid:实线
            }
          },
          axisTick: {
            show: false // 是否显示刻度
          },
          minInterval: 1,
          min: config.min,
          axisLabel: {
            color: '#868686', // x轴字体颜色
            interval: 0 // 轴显示所有的数据
          },
          nameTextStyle: {
            color: '#868686',
            align: 'right',
            padding: [0, 6, 0, 0]
          }
        },
        series: [
          {
            name: config.title,
            data: config.dataY,
            type: 'bar',
            barMaxWidth: 100,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: config.colorStart }, // 渐变色起始颜色
                { offset: 1, color: config.colorEnd } // 渐变色结束颜色
              ])
            }
          }
        ]
      }
    },
    getLessonData() {
      lessonData({ id: this.id }).then(res => {
        if (res.code != 200) return
        const data = { ...res.data.baseData }
        for (const key in data) {
          if (!data[key]) data[key] = '--'
        }
        const classData = data
        this.classData.push(classData)
        this.overviewAttendance = res.data.attendanceData
        this.overviewTraining = res.data.trainingData
        this.overviewTeach = res.data.teachData
        this.attendanceList = res.data.attendanceData.list
        this.trainingList = res.data.trainingData.list
        this.teachList = res.data.teachData.list
        this.studentList = res.data.studentList
        this.initEchartAttendance(
          res.data.attendanceData.list.map(item => item.studentName),
          res.data.attendanceData.list.map(item => (item.value / 60))
        )
        this.initEchartTraining(
          res.data.trainingData.list.map(item => item.studentName),
          res.data.trainingData.list.map(item => ({
            value: item.count,
            detailInfo: item.list
          }))
        )
        this.initEchartTeach(
          res.data.teachData.list.map(item => item.studentName),
          res.data.teachData.list.map(item => (item.value / 60))
        )
      })
    }
  },
  mounted() {
    this.id = Number(this.$route.query.id) || 0
    this.lessonName = this.$route.query.name || undefined
    this.getLessonData()
    this.$nextTick(() => {
      this.handleScorll()
    })
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  overflow: hidden;
  padding: 18px 19px;
  .anchor {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-top: 26px;
    div {
      margin-right: 40px;
      position: relative;
      cursor: pointer;
    }
    .checked {
      width: 23px;
      height: 4px;
      border-radius: 4px;
      background: #ff6d00;
      position: absolute;
      left: 50%;
      bottom: -10px;
      transform: translateX(-12px);
    }
    a {
      color: #000;
    }
  }
  .back {
    width: 80px;
    height: 34px;
    display: flex;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-radius: 25px;
    align-items: center;
    justify-content: center;
    border: 1px solid #d6d6d6;
    img {
      height: 10px;
      margin-right: 9px;
    }
  }
  .scrollContent {
    padding-right: 15px;
    height: calc(100vh - 220px);
    overflow-y: scroll;
    margin-top: 21px;
    .list {
      background: #f8fafc;
      margin: 22px 0;
      padding: 21px;
      position: relative;
      .qa {
        font-size: 16px;
        line-height: 30px;
        font-weight: bold;
      }
      .opiton {
        line-height: 50px;
      }
      .answer {
        font-weight: bold;
        line-height: 30px;
      }
      .grade {
        position: absolute;
        right: 10px;
        top: 0px;
        width: 33px;
        height: 35px;
        text-align: center;
        line-height: 30px;
        background-size: 100% 100%;
        font-style: italic;
      }
    }
  }
  .title {
    color: #000;
    display: flex;
    color: #4b6175;
    font-weight: 600;
    padding-bottom: 13px;
    margin-bottom: 20px;
    margin-top: 26px;
    align-items: flex-end;
    justify-content: space-between;
    border-bottom: 1px solid #e2e5e7;
    span {
      font-size: 15px;
    }
  }
  .base .title{
    margin-top: 0;
  }
  .overview {
    padding: 9px 20px;
    background: rgba(237, 242, 246, 0.35);
    font-weight: 500;
    font-size: 12px;
    color: #788aa3;
    line-height: 17px;
    margin-top: 15px;
    span {
      padding-right: 48px;
    }
  }
  .detail {
    position: relative;
    .noData {
      position: absolute;
      top: 52.5%;
      left: 51.5%;
      transform: translate(-50%, -50%);
      width: 97%;
      height: 75%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: linear-gradient( 180deg, #fff 0%, #F1F7FF 100%);
      > img{
        width: 162px;
        height: 135px;
      }
      span{
        font-weight: bold;
        font-size: 12px;
        color: #8994A1;
        line-height: 17px;
        text-align: center;
        font-style: normal;
        margin-top: -28px;
      }
    }
  }
  .data {
    color: #000;
    margin-bottom: 5px;
    background: #f6f6f6;
    border-radius: 6px;
    padding: 10px 16px;
    span {
      font-weight: 550;
      font-size: 14px;
      color: #677f89;
      margin-right: 90px;
    }
  }
  .echart {
    width: 100%;
    height: 300px;
  }
  .ant-table,
  .ant-btn {
    color: #000;
  }
  .ant-tabs {
    // height: calc(100% -70px);
  }
  /deep/.ant-tabs-bar {
    border-bottom: 0;
  }
  /deep/.ant-tabs-nav.ant-tabs-nav-animated > div {
    width: 100%;
    display: flex;
    .ant-tabs-tab {
      color: #000;
      margin-right: 0;
      padding: 9px 22px 9px 0;
    }
  }
  /deep/.ant-tabs-nav-container-scrolling {
    padding-left: 0;
    padding-right: 64px;
  }
  /deep/.ant-tabs-tab-prev {
    margin-left: calc(100% - 64px);
  }
  /deep/.ant-tabs-tab-active.ant-tabs-tab {
    display: flex;
    font-weight: 550;
    justify-content: center;
    position: relative;
    justify-content: center;
    &:after {
      bottom: 0;
      content: '';
      width: 21px;
      height: 3px;
      border-radius: 3px;
      position: absolute;
      background: #ff6d00;
    }
  }
  /deep/.ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
    display: none !important;
  }
  .student-data {
    height: 100%;
    position: relative;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    /deep/.list-pagination {
      width: 100%;
      bottom: 40px;
      position: absolute;
      .pagination {
        padding: 12px 0 0;
      }
    }
  }
  .overall.student-data {
    padding-bottom: 40px;
  }
}
.lesson-data::-webkit-scrollbar {
  display: none;
}
</style>
